import { useMemo } from "react";
import { useLanguage, type LanguageCode } from "@/contexts/LanguageContext";
import { enUS, sv, nb, da, fi, de, nl, fr, es, it } from "date-fns/locale";
import type { Locale } from "date-fns";

const LOCALE_MAP: Record<LanguageCode, Locale> = {
  en: enUS,
  sv: sv,
  no: nb,
  da: da,
  fi: fi,
  de: de,
  nl: nl,
  fr: fr,
  es: es,
  it: it,
};

/**
 * Returns the date-fns Locale object for the current language.
 * Pass to `format(date, pattern, { locale })` for localized date strings.
 */
export function useLocalizedDate() {
  const { language } = useLanguage();
  const locale = useMemo(() => LOCALE_MAP[language] ?? enUS, [language]);
  return { locale };
}
